import { useCallback, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { USER_FLAGS } from 'config';
import useBuyDetailsTariff from 'hooks/useBuyDetailsTariff';
import useCheckPackage from 'hooks/useCheckPackage';
import { backToPageThatCausedAuth } from 'actions/app';
import loginDataService from 'utils/login-data-service';

const useOnSuccessLogin = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const searchParams = useMemo(() => new URLSearchParams(history.location.search), [history]);
  const isRegistration = history.location.pathname.includes('registration');

  const buyTariffAction = useBuyDetailsTariff(searchParams.get('vodAssetId'));
  const checkPackage = useCheckPackage();

  const handler = useCallback(
    async ({ contractNumber }) => {
      const userFlag = loginDataService.get()?.userFlag;
      const isLifecellUser = userFlag === USER_FLAGS.LIFECELL;

      // TVOD
      if (searchParams.has('tariffId')) {
        dispatch(backToPageThatCausedAuth());
        await buyTariffAction({ tariffId: searchParams.get('tariffId'), contractCode: contractNumber });
        return;
      }
      // SUBS
      if (searchParams.has('pkgId') || searchParams.has('channelId') || searchParams.has('vodAssetId')) {
        await checkPackage(contractNumber, isLifecellUser);
        return;
      }

      // if ONLY onSuccess (for Promocode case)
      if (searchParams.has('onSuccess')) {
        await dispatch(backToPageThatCausedAuth());
        // Timeout is necessary here
        setTimeout(() => history.push(decodeURIComponent(searchParams.get('onSuccess'))), 0);
        return;
      }

      // DEFAULT
      await dispatch(backToPageThatCausedAuth());
      // https://hootko.atlassian.net/browse/STVWL-583
      const url = isRegistration && !isLifecellUser ? '/profile/packages/all' : '/';
      // Timeout is necessary here
      setTimeout(() => history.push(url), 0);
    },
    [buyTariffAction, checkPackage, dispatch, history, isRegistration, searchParams],
  );

  return handler;
};

export default useOnSuccessLogin;
